import { StylesheetJson } from "cytoscape";
import React, { useMemo } from "react";

import { Modal } from "src/components/Modal";
import { InlineNotification } from "src/components/Notifications/InlineNotification";
import { useGetIdentifiedCasesGraphData } from "src/dynamic-view-renderer/Widgets/RelatedCases/IdentifierGraph/identifierGraph.mapping.ts";
import { RelatedCasesDisplayElementConfig } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { WidgetProperty } from "src/dynamic-view-renderer/Widgets/Widget.typings.ts";
import useIdentifiedCases from "src/graphql/anti-fraud/queries/alerts/GetIdentifiedCasesQuery.ts";
import { useT } from "src/internationalization";
import { useTheme } from "src/theme";

import { getOldLayout, oldStyles } from "../Graph/oldLayout/old.styles";
import RelatedCasesGraphComponent from "../Graph/RelatedCasesGraphComponent";

export type IdentifierGraphModalProps = {
  closeModal: () => void;
  subTitle: React.ReactNode;
  identifier: WidgetProperty;
  configuration: RelatedCasesDisplayElementConfig[];
};

const IdentifierGraphModal: React.FC<IdentifierGraphModalProps> = ({
  closeModal,
  identifier,
  configuration,
  subTitle,
}) => {
  const t = useT();
  const { colors } = useTheme();

  const {
    data: identifiedCases,
    loading,
    error,
  } = useIdentifiedCases({
    identifierId: identifier.id ?? "",
    options: { pagination: { limit: 20, offset: 0 } },
  });

  const graphData = useGetIdentifiedCasesGraphData(identifiedCases, configuration, identifier);

  const graphStyles = useMemo(() => {
    return oldStyles(colors) as StylesheetJson;
  }, [colors]);

  return (
    <Modal
      title={subTitle}
      onClose={closeModal}
      size="lg"
      fullHeight={loading || !error}
      noPaddingX
      closeOnEscape={false}
      closeOnOutsideClick={false}
    >
      {error && (
        <div className="p-5 h-full">
          <InlineNotification kind="error" title={t("general.error")} subtitle={error.message} />
        </div>
      )}
      {!error && (
        <div style={{ width: "100%", height: "100%" }}>
          <RelatedCasesGraphComponent
            isFullScreen={false}
            graphData={graphData}
            isLoading={loading}
            graphLayout={getOldLayout("elk")}
            graphStyles={graphStyles}
          />
        </div>
      )}
    </Modal>
  );
};

export default IdentifierGraphModal;
